import './reportColumn.scss';
import React from 'react';
import moment from 'moment-timezone';



// Функция для форматирования даты
// function formatDate(dateString) {
//     const date = new Date(dateString);

//     // Получаем компоненты даты
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();
//     const hours = String(date.getHours() + 5).padStart(2, '0');
//     const minutes = String(date.getMinutes()).padStart(2, '0');

//     // Форматируем строку в виде "dd.MM.yyyy HH:mm"
//     return `${day}.${month}.${year} ${hours}:${minutes}`;
// }




const ReportColumn = ({ title, reports, getNameById, expandedReports, handleReportClick, type, passport }) => {

    const sortedReports = reports.sort((a, b) => new Date(b.completionDate) - new Date(a.completionDate));

    

    return (
        <div className="reportColumn">
            <h5 className="reportColumn__title">{title}</h5>
            {sortedReports.map((report) => (
                <div key={report.id} className="reportColumn-row" onClick={() => handleReportClick(report.id)}>
                    <div className="reportColumn-row__wrapper d-flex">
                        <p className={passport ? "reportColumn-row__text--invisible" : "reportColumn-row__text"}>{getNameById(type, report[`form${type}Id`])}</p>
                        <p className="reportColumn-row__text">{moment.tz(report.completionDate, "Asia/Vladivostok").format("HH:mm DD.MM.YYYY")}</p>
                    </div>
                    <p className={`reportColumn-row__description ${expandedReports[report.id] ? 'reportColumn-row__description--expanded' : ''}`}
                    >{report.description}</p>
                </div>
            ))}
        </div>
    )
}

export default ReportColumn;